import { GridContainer } from 'libs/ui';
import { User } from 'grids/user/user';

const UserWrapper = (props) => {
  return (
    <GridContainer>
      <User {...props} />
    </GridContainer>
  );
};

export default UserWrapper;
